/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { FaInstagram, FaFacebook } from "react-icons/fa";
import logo1 from "../assets/glowin-png2.png";

const Footer: React.FC = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    mensaje: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");

    if (!formData.nombre || !formData.email) {
      setErrorMessage("Nombre y email son obligatorios.");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch("http://localhost:5000/send-job-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSuccessMessage("Tu mensaje ha sido enviado. ¡Gracias por contactarnos!");
        setFormData({ nombre: "", email: "", mensaje: "" });
      } else {
        setErrorMessage("Hubo un problema al enviar tu mensaje. Inténtalo de nuevo.");
      }
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      setErrorMessage("Hubo un problema al enviar tu mensaje. Inténtalo de nuevo.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container text-center md:text-start mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Información de contacto */}
        <div>
          <h3 className="text-xl font-semibold mb-4">Cómo Contactarnos</h3>
          <ul className="space-y-6">
            <li className="text-lg">
              Email:{" "}
              <a
                href="mailto:glowin.arg@gmail.com"
                className="text-blue-400 hover:underline text-lg"
              >
                glowin.arg@gmail.com
              </a>
            </li>
            <li className="text-lg">
              Teléfono:{" "}
              <a
                href="tel:+541126413277"
                className="text-blue-400 hover:underline text-lg"
              >
                +54 (11) 2641-3277
              </a>
            </li>
            <li className="text-lg">
              Nuestras Redes:
              <div className="flex justify-center md:justify-start space-x-4 mt-2">
                <a
                  href="https://www.instagram.com/glowinwash/"
                  aria-label="Instagram"
                  className="text-blue-400 hover:text-blue-600"
                >
                  <FaInstagram size={24} />
                </a>
                <a
                  href="#"
                  aria-label="Facebook"
                  className="text-blue-400 hover:text-blue-600"
                >
                  <FaFacebook size={24} />
                </a>
              </div>
            </li>
          </ul>
        </div>

        {/* Logo */}
        <div className="flex justify-center md:justify-center">
          <img
            src={logo1}
            alt="Logo de Glowin"
            className="h-50 relative md:left-[-60px] top-[-5px] w-[250px] h-[270px] md:w-[320px] md:h-[348px]"
          />
        </div>

        {/* Formulario Trabaja con Nosotros */}
        <div id="trabaja-con-nosotros">
          <h3 className="text-xl font-semibold mb-4">Trabajá con nosotros</h3>
          <form onSubmit={handleSubmit} className="bg-gray-800 p-4 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 gap-4">
              {/* Nombre */}
              <input
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                className="block w-full h-11 pr-5 pl-3 text-base font-normal shadow-xs text-white bg-transparent border border-gray-300 rounded-full placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                placeholder="Ingresá tu nombre"
                required
              />
              {/* Email */}
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="block w-full h-11 pr-5 pl-3 text-base font-normal shadow-xs text-white bg-transparent border border-gray-300 rounded-full placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                placeholder="Ingresá tu email"
                required
              />
              {/* Mensaje */}
              <textarea
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                className="block w-full h-24 pr-5 pl-3 text-base font-normal shadow-xs text-white bg-transparent border border-gray-300 rounded-lg placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                placeholder="Escribe tu mensaje"
              ></textarea>
              {/* Botón Enviar */}
              <button
                type="submit"
                className="w-full h-12 shadow-sm rounded-full bg-yellow-500 hover:bg-yellow-400 transition-all duration-300 text-black text-base font-semibold"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Enviando..." : "Enviar Mensaje"}
              </button>
            </div>
          </form>
          {/* Mensajes de éxito/error */}
          {successMessage && <p className="text-green-400 mt-4">{successMessage}</p>}
          {errorMessage && <p className="text-red-400 mt-4">{errorMessage}</p>}
        </div>
      </div>

      {/* Sub Footer */}
      <div className="bg-gray-800 py-4 text-center text-sm text-gray-400">
        <span>
          &copy; 2025 Glowin. Todos los derechos reservados.{" "}
          {/* <a href="#" className="hover:underline">
            Mapa del Sitio
          </a>{" "}
          |{" "}
          <a href="#" className="hover:underline">
            Términos y condiciones
          </a>{" "}
          |{" "}
          <a href="#" className="hover:underline">
            Política de privacidad
          </a> */}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
